import { render, staticRenderFns } from "./stores.popover.vue?vue&type=template&id=72da931c"
import script from "./stores.popover.vue?vue&type=script&lang=js"
export * from "./stores.popover.vue?vue&type=script&lang=js"
import style0 from "./stores.popover.vue?vue&type=style&index=0&id=72da931c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports